import icon from 'assets/img/icons/icon-warning.svg'
import useProfile from 'hooks/useProfile'

const PurchaseWindowFail = ({ close }) => {
  const {errorText} = useProfile();

  const getAdditionalTitle = (errorText) => {
    if (errorText === '' || errorText.includes('limit')) {
      return 'Purchase Declined!';
    }

    if (errorText.includes('no event card found for collection')) {
      return 'No Eligible Events';
    }

    if (errorText.includes('Insufficient funds')) {
      return 'Insufficient Funds';
    }

    return 'Error';
  };

  const getAdditionalText = (errorText) => {
    if (errorText) {
      return errorText;
    }

    return 'An unexpected error occurred.';
  };

  return (
    <>
      <header className="modal-window__header">
        <img src={icon} className="modal-window__icon" alt="" />
        <h5 className="modal-window__title">{getAdditionalTitle(errorText)}</h5>
        <p className="modal-window__info">
          {getAdditionalText(errorText)}
        </p>
      </header>
      <footer className="modal-window__footer">
        <button className="modal-window__footer-close" onClick={close}>Done</button>
      </footer>
    </>
  )
}

export default PurchaseWindowFail
